module.exports = __webpack_public_path__ + "images/53bcd9eaa4cac0f3227f3422157003fc.svg";